"use strict";

import module from "./module";

export default module;
